export type ConfirmDialogTranslation = {
  buttons: {
    cancel: string;
    close: string;
    confirm: string;
  };
  title: string;
};

export const confirmDialogTranslation: ConfirmDialogTranslation = {
  buttons: {
    cancel: 'Cancel',
    close: 'Close',
    confirm: 'Confirm',
  },
  title: 'Confirmation',
};
